import { mapMutations, mapActions } from "vuex";
export default {
    data() {
        return {
            taskID: ''
        };
    },
    methods: {
        ...mapActions(["feedbackBtnEvent"]),
        ...mapMutations([
            "SET_TEMP_ORDER_INFO"
        ]),
        // 差价反馈
        showDiff({taskID = '', dataInfo = null, platform = 0}) {
            this.feedbackBtnEvent({readyTaskId: taskID, dataInfo, platform})
        },
    },
}